module.exports = __webpack_public_path__ + "img/alice-patel.61463a71.jpg";